"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _storefrontPreview = require("./storefront-preview");
Object.keys(_storefrontPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _storefrontPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _storefrontPreview[key];
    }
  });
});